import React, { FC, lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { ROUTES } from 'utils'

import PrivateRoutes from 'components/PrivateRoutes'
import Loading from 'components/Loading'

const Main = lazy(() => import('pages/Main'))
const Auth = lazy(() => import('pages/Auth'))
const Documentation = lazy(() => import('pages/Documentation'))
const LicenseAgreement = lazy(() => import('pages/LicenseAgreement'))
const Profile = lazy(() => import('pages/Profile'))
const ConfirmAlpha = lazy(() => import('pages/ConfirmAlpha'))
// const Map = lazy(() => import('pages/Map'))


export const RouteContainer: FC = () => {
  return (
    <Suspense fallback={<Loading active/>}>
      <Routes>
        <Route path={ROUTES.MAIN} element={<Main/>}/>
        <Route path={ROUTES.AUTH} element={<Auth/>}/>
        <Route path={ROUTES.CONFIRM_ALPHA} element={<ConfirmAlpha/>}/>
        <Route path={ROUTES.DOCUMENTATION} element={<Documentation/>}/>
        <Route path={ROUTES.LICENSE_AGREEMENT} element={<LicenseAgreement/>}/>
        {/*<Route path={ROUTES.MAP} element={<Map/>}/>*/}
        <Route element={<PrivateRoutes/>}>
          <Route path={ROUTES.PROFILE} element={<Profile/>}/>
        </Route>
        <Route path={'*'} element={<Navigate to={ROUTES.MAIN} replace/>}/>
      </Routes>
    </Suspense>
  )
}
